import React from 'react';
import {formatRegionDate} from "../../helpers/regionDate";

const RegionDateField = ({source, format, record = {}}) =>
    <span>{formatRegionDate(record[source], format)}</span>;

RegionDateField.defaultProps = {
    format: "DD.MM.YYYY, HH:mm"
};

export default RegionDateField;
